// === Libs ===
import React, { FC, useState } from 'react';

// === Style ===
import classes from './side-bar.module.scss';
import Button from '@/common/components/ui/buttons/button/button';
import { useHistory, useParams } from 'react-router-dom';
import { CalendarState } from '@/common/components/ui/calendar/calendar';
import { assistantService } from '@/services/assistant/assistant.service';
import FilterSet, { InputField } from '@/components/filter-set/filter-set';
import { withAlert } from '@/helpers/notificationHelper';

interface SideBarInterface {
  dispatcher: React.Dispatch<CalendarState>;
  state: CalendarState;
  canAdd?: boolean;
  canDownload?: boolean;
}

const SideBarProto: FC<SideBarInterface> = ({
  dispatcher,
  state,
  canAdd = true,
  canDownload = false,
}) => {
  const { id } = useParams<{ id: string }>();

  const history = useHistory();
  let [filters, setFilters] = useState({});

  const filterConfig: InputField[] = [
    {
      name: 'searchQuery',
      value: false,
      text: 'Поиск',
      input: 'text',
    },
  ];

  return (
    <div className={classes.sideBar}>
      {canDownload && (
        <div className={classes['add-button-wrapper']}>
          <Button
            color={'primary'}
            onClick={() =>
              withAlert(() => assistantService.getAnnualReport(id))
            }
            fullWidth>
            Скачать совокупный отчет
          </Button>
        </div>
      )}
      <FilterSet state={filters} setState={setFilters} config={filterConfig} />
    </div>
  );
};

export const SideBar = React.memo(SideBarProto);
